

/// <reference path="PaymentTransaction.ts" />

// Generated class ProxyPaymentTransaction_ManagedObject

class ProxyPaymentTransaction_ManagedObject extends PaymentTransaction
{

    // Property: cardBrand
    set cardBrand(value:string) {
        this.setValueForKey(value, 'cardBrand');
    }
    get cardBrand():string {
        return this.valueForKey('cardBrand');
    }
    set cardBrandPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cardBrand');
    }
    get cardBrandPrimitiveValue():string {
        return this.primitiveValueForKey('cardBrand');
    }

    // Property: cardSummary
    set cardSummary(value:string) {
        this.setValueForKey(value, 'cardSummary');
    }
    get cardSummary():string {
        return this.valueForKey('cardSummary');
    }
    set cardSummaryPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cardSummary');
    }
    get cardSummaryPrimitiveValue():string {
        return this.primitiveValueForKey('cardSummary');
    }

    // Property: cardVariant
    set cardVariant(value:string) {
        this.setValueForKey(value, 'cardVariant');
    }
    get cardVariant():string {
        return this.valueForKey('cardVariant');
    }
    set cardVariantPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cardVariant');
    }
    get cardVariantPrimitiveValue():string {
        return this.primitiveValueForKey('cardVariant');
    }

    // Property: has3DS
    set has3DS(value:boolean) {
        this.setValueForKey(value, 'has3DS');
    }
    get has3DS():boolean {
        return this.valueForKey('has3DS');
    }
    set has3DSPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'has3DS');
    }
    get has3DSPrimitiveValue():boolean {
        return this.primitiveValueForKey('has3DS');
    }

    // Property: netAmount
    set netAmount(value:number) {
        this.setValueForKey(value, 'netAmount');
    }
    get netAmount():number {
        return this.valueForKey('netAmount');
    }
    set netAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'netAmount');
    }
    get netAmountPrimitiveValue():number {
        return this.primitiveValueForKey('netAmount');
    }

    // Property: notifyData
    set notifyData(value:any) {
        this.setValueForKey(value, 'notifyData');
    }
    get notifyData():any {
        return this.valueForKey('notifyData');
    }
    set notifyDataPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'notifyData');
    }
    get notifyDataPrimitiveValue():any {
        return this.primitiveValueForKey('notifyData');
    }

    // Property: notifySchema
    set notifySchema(value:string) {
        this.setValueForKey(value, 'notifySchema');
    }
    get notifySchema():string {
        return this.valueForKey('notifySchema');
    }
    set notifySchemaPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'notifySchema');
    }
    get notifySchemaPrimitiveValue():string {
        return this.primitiveValueForKey('notifySchema');
    }

    // Property: schema
    set schema(value:string) {
        this.setValueForKey(value, 'schema');
    }
    get schema():string {
        return this.valueForKey('schema');
    }
    set schemaPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schema');
    }
    get schemaPrimitiveValue():string {
        return this.primitiveValueForKey('schema');
    }

    // Property: schemaAppID
    set schemaAppID(value:string) {
        this.setValueForKey(value, 'schemaAppID');
    }
    get schemaAppID():string {
        return this.valueForKey('schemaAppID');
    }
    set schemaAppIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaAppID');
    }
    get schemaAppIDPrimitiveValue():string {
        return this.primitiveValueForKey('schemaAppID');
    }

    // Property: schemaAppSource
    set schemaAppSource(value:string) {
        this.setValueForKey(value, 'schemaAppSource');
    }
    get schemaAppSource():string {
        return this.valueForKey('schemaAppSource');
    }
    set schemaAppSourcePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaAppSource');
    }
    get schemaAppSourcePrimitiveValue():string {
        return this.primitiveValueForKey('schemaAppSource');
    }

    // Property: schemaBusinessAreaID
    set schemaBusinessAreaID(value:string) {
        this.setValueForKey(value, 'schemaBusinessAreaID');
    }
    get schemaBusinessAreaID():string {
        return this.valueForKey('schemaBusinessAreaID');
    }
    set schemaBusinessAreaIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaBusinessAreaID');
    }
    get schemaBusinessAreaIDPrimitiveValue():string {
        return this.primitiveValueForKey('schemaBusinessAreaID');
    }

    // Property: schemaDocumentNumber
    set schemaDocumentNumber(value:string) {
        this.setValueForKey(value, 'schemaDocumentNumber');
    }
    get schemaDocumentNumber():string {
        return this.valueForKey('schemaDocumentNumber');
    }
    set schemaDocumentNumberPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaDocumentNumber');
    }
    get schemaDocumentNumberPrimitiveValue():string {
        return this.primitiveValueForKey('schemaDocumentNumber');
    }

    // Property: schemaPlaceID
    set schemaPlaceID(value:string) {
        this.setValueForKey(value, 'schemaPlaceID');
    }
    get schemaPlaceID():string {
        return this.valueForKey('schemaPlaceID');
    }
    set schemaPlaceIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaPlaceID');
    }
    get schemaPlaceIDPrimitiveValue():string {
        return this.primitiveValueForKey('schemaPlaceID');
    }

    // Property: schemaTransactionID
    set schemaTransactionID(value:string) {
        this.setValueForKey(value, 'schemaTransactionID');
    }
    get schemaTransactionID():string {
        return this.valueForKey('schemaTransactionID');
    }
    set schemaTransactionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaTransactionID');
    }
    get schemaTransactionIDPrimitiveValue():string {
        return this.primitiveValueForKey('schemaTransactionID');
    }

    // Property: webHook
    set webHook(value:string) {
        this.setValueForKey(value, 'webHook');
    }
    get webHook():string {
        return this.valueForKey('webHook');
    }
    set webHookPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'webHook');
    }
    get webHookPrimitiveValue():string {
        return this.primitiveValueForKey('webHook');
    }
}
